import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'prettyTransform' })
export class PrettyTransformPipe implements PipeTransform {
  public transform(value: string | string[]): string {
    return (typeof value === 'string' ? [value] : value instanceof Array ? value : [])
      .map((it) =>
        it
          .replace(/-/g, ' ')
          .split(' ')
          .map((word) => (word[0]?.toUpperCase() ?? '') + word.substring(1))
          .join(' ')
      )
      .join(', ');
  }
}
